<template>
  <el-dialog
    append-to-body
    width="70%"
    title="浏览人员"
    center
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-table
      :data="table.data"
      :height="500"
      style="width: 100%"
      v-loading="table.loading"
      element-loading-text="拼命加载中"
      :show-header="false"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0)"
      :header-cell-style="{ background: '#f5f5f5' }"
    >
      <el-table-column label="序号" type="index" width="60" align="center">
      </el-table-column>
      <el-table-column label="" prop="avatar" width="60" align="center">
        <template #default="{ row }">
          <el-avatar size="small" :src="row.avatar"></el-avatar>
        </template>
      </el-table-column>
      <el-table-column label="" prop="nickname" min-width="100">
        <template #default="{ row }">
          <div class="pointer" @click="viewFlexUser(row)">
            {{ row.nickname }}
          </div>
          <div style="font-size: 12px">{{ row.browse_time }} 查看</div>
        </template>
      </el-table-column>
      <el-table-column label="" prop="sex" width="80" align="center">
        <template #default="{ row }">
          <div>{{ { 0: "未填", 1: "男", 2: "女" }[row.sex] }}</div>
          <div>{{ row.age }}岁</div>
        </template>
      </el-table-column>
      <el-table-column label="" prop="user_score" min-width="140">
        <template #default="{ row }">
          <el-rate
            v-model="row.user_score"
            disabled
            text-color="#ff9900"
            v-if="!!row.user_score"
          ></el-rate>
          <div v-else>暂无评分</div>
          <div>服务{{ row.service_num }}次</div>
        </template>
      </el-table-column>
      <el-table-column label="" prop="is_apply" min-width="120" align="center">
        <template #default="{ row }">
          <div v-if="row.is_apply == 1 && (!Number(row.apply_amount) && !Number(row.apply_unit_price))">已报名</div>
          <template v-if="row.is_apply == 1 && (Number(row.apply_amount) || Number(row.apply_unit_price))">
            <div v-if="row.salary_type == 0">报价:￥{{row.apply_amount}}</div>
            <div v-if="row.salary_type == 1">报价:￥{{row.apply_unit_price}}/小时</div>
            <div v-if="row.salary_type == 2">报价:￥{{row.apply_unit_price}}/天</div>
          </template>
          <div>{{ row.apply_time }}</div>
        </template>
      </el-table-column>
      <el-table-column label="" prop="phone_time" min-width="100">
        <template #default="{ row }">
          <template v-if="row.phone_time">
            <div>已获取号码</div>
            <div style="font-size: 12px">{{ row.phone_time }}</div>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination__wrap">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="table.params.page"
        :page-size="table.params.count"
        :total="table.total"
        :page-sizes="[10, 20, 50, 100, 150]"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
    <template #footer>
      <el-row type="flex" justify="center">
        <el-button @click="toggle(false)">关闭</el-button>
      </el-row>
    </template>
    <blowWorkerMpDialog ref="blowWorkerMpDialogRef"></blowWorkerMpDialog>
  </el-dialog>
</template>

<script>
import { mixinTable } from "@/mixins/table.js";
import blowWorkerMpDialog from "./blowWorkerMpDialog.vue";
export default {
  mixins: [mixinTable],
  components: {
    blowWorkerMpDialog,
  },
  data() {
    return {
      visible: false,
      loading: false,
      info: {},
      table: {
        loading: false,
        params: {
          page: 1,
          count: 10,
        },
        data: [],
        total: 0,
      },
    };
  },
  methods: {
    // 获取详情
    getDetail(row) {
      this.info = row;
      this.getTable();
    },
    getTable() {
      let params = {
        ...this.table.params,
        id: this.info.id,
      };
      this.table.loading = true;
      this.$http
        .get("/admin/flex_job/browseLog", { params })
        .then((res) => {
          if (res.code == 1) {
            this.table.data = res.data.list;
            this.table.total = res.data.total;
          }
        })
        .finally(() => {
          this.table.loading = false;
        });
    },
    viewFlexUser(row) {
      let dom = this.$refs.blowWorkerMpDialogRef;
      dom.toggle(true);
      dom.getDetail(row);
    },
    reset(done) {
      this.table = {
        loading: false,
        params: {
          page: 1,
          count: 10,
        },
        data: [],
        total: 0,
      };
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
  },
};
</script>
